import React, { useEffect, useState } from 'react';
import { TextField, MenuItem, WithStyles } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import styles from './styles';
import { getBuilderId } from '../../redux/selectors/auth';
import { usePermissions } from '../../hooks/usePermissions';

type Props = {
  defaultTimezone?: number | null;
  timezones: any;
} & TextFieldProps & WithStyles<typeof styles>;

const TimezoneSelect: React.FC<Props> = (props) => {
  const {
    defaultTimezone, timezones, classes, ...textFieldProps
  } = props;

  const [filteredTimezone, setFilteredTimezone] = useState([]);
  const builderId = useSelector(getBuilderId);

  const { canEdit } = usePermissions();

  useEffect(() => {
    const shouldFilter = builderId && builderId !== 706;
    const filterTimezones = shouldFilter
      ? timezones.filter((item: any) => item.catalog_id !== 171)
      : timezones;

    setFilteredTimezone(filterTimezones);
  }, [builderId, timezones]);


  return (
    <TextField
      fullWidth
      {...textFieldProps}
      value={defaultTimezone || ''}
      className={classes.select}
      select
      inputProps={{ classes: { root: classes.input, disabled: classes.disabledInput } }}
      disabled={!canEdit}
    >
      <MenuItem value="" disabled>
        Choose a timezone
      </MenuItem>
      {filteredTimezone.map(({ catalog_id: catalogId, value }: any) => (
        <MenuItem
          key={catalogId}
          value={catalogId}
        >
          {value}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default React.memo(TimezoneSelect);
